import isObject from 'lodash/isObject';

export const safeJsonParse = (value: string): Record<PropertyKey, any> => {
  try {
    const result = JSON.parse(value);
    if (!isObject(result)) {
      return {};
    }
    return result;
  } catch {
    return {};
  }
};
